// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2A53L","consentsList":"PatientConsents_consentsList__2Usl1","consentsListEmpty":"PatientConsents_consentsListEmpty__lQ4wA"};